import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col, notification, message, Button, Modal, Tooltip } from "antd";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import { FaMaximize, FaMinimize } from "react-icons/fa6";

import FooterButtons from "./../components/STORM/FooterButtons";
import HModal from "./HModal";
import liracrypt from "../components/Liracrypt/liracrypt";
import SessionError from "../components/ApiErrorComp/SessionError";
import ZenFormInput from "./InputCreater/ZenFormInput";
import { useLocation, useParams, useHistory } from "react-router-dom";
import queryString from "query-string";
import ZenMultiLines from "../components/PhantomZen/ZenMultiLines";
import RoutePage from "../components/RoutePage";
import dayjs from "dayjs";
import ReactToPrint from 'react-to-print';
import { useSelector } from "react-redux";
import { createRoute } from "../utils/CustomFunc";
import StAddNew from "./DSeries/StAddNew";
import ZenModal from "../components/ZenModal";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";

function ZenForm({
  setSmodalTitle,
  urlMethod,
  colSpan,
  setPageHeader,
  urlEndpoint,
  urlData,
  dictName,
  pageName,
  extraData,
  ModalHeader,
  onCallFinish,
  initForm,
}) {
  let componentRef = useRef();

  const history = useHistory();
  const { search } = useLocation();
  const urlCode = useSelector(state => state.urlCode);
  const searchParams = queryString.parse(search);

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  let { typ } = useParams();
  let { subtyp } = useParams();
  // if (setPageHeader) {
  //   setPageHeader(pageName);
  // };
  const paramsData = {
    typ,
    subtyp,
    ...searchParams
  }
  const [loader, setLoader] = useState(false);
  const LocalDict = [];
  const [pageConfig, setPageConfig] = useState();
  const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
  const [footerButtons, setFooterButtons] = useState({});
  const [modalElement, setModalElement] = React.useState(null);
  const [url, setUrl] = React.useState(null);
  const [method, setMethod] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loginError, setLoginError] = React.useState(false);
  // const [submitBtnText, setSubmitBtnTxt] = React.useState("Add New");
  const [render, setRender] = React.useState(true);

  const [modalHeader, setModalHeader] = React.useState(ModalHeader);
  const [selectedButton, setSelectedButton] = useState();
  const [isHModalVisible, setIsHModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const [fullScreenIcon, setFullScreenIcon] = useState({});

  const [_form] = Form.useForm();


  const form = initForm ? initForm : _form;

  const [zenModal, setZenModal] = useState();
  const [modal, setModal] = useState({
    // type: props.config.zenModal.typ,
    type: "",
    data: undefined,
    show: false,
    loading: false,
  });
  const toggleModal = ({ show = false, data = undefined, type = "", loading = false }) => {
    setModal({ show, data, type, loading });
  }

  const openPopupModal = (button) => {
    setIsHModalVisible(true);
    setAction({ edit: button.popUpModalProp });
  }


  const toggleFullScreen = () => {
    var isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null);

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      setFullScreenIcon('minimize');
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      setFullScreenIcon('maximize');
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }

  const openSmodal = (btnData) => {
    setZenModal(btnData.smodalProp);
    let urlData = { ...searchParams, ...btnData?.smodalProp?.params };
    if (btnData.smodalProp?.multiProps?.length) {
      btnData.smodalProp?.multiProps.forEach(x => {
        urlData[x] = form.getFieldValue(x);
      })
    }
    return toggleModal({
      show: true,
      data: {
        urlData: { ...urlData }
      },
      type: 'smodal',
      loading: false
    });
  }

  const onResponse = ({ data, button, onlyPostSubmitAction }) => {
    if (data && !onlyPostSubmitAction) {
      if (data?.isSuccess) {
        message.success(data?.message || "Submitted Successfully");
      } else {
        message.error(data?.message || "Oops! Something went wrong");
        return;
      };

    }
    let btnData = button || selectedButton;
    if (btnData.buttonProp?.smodal && !onlyPostSubmitAction) {
      return openSmodal(btnData);
    };
    if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
      return openPopupModal(btnData);
    };
    if (!btnData?.buttonProp?.postSubmitAction) {
      if (onCallFinish) {
        form.resetFields();
        onCallFinish({});
      }
      return;
    };

    if (btnData?.postSubmitActionProp?.action === "clearForm") {
      form.resetFields();
    }
    if (btnData?.postSubmitActionProp?.action === "newRoute") {
      let route = createRoute({
        route: btnData.postSubmitActionProp.route,
        props: btnData?.postSubmitActionProp?.props,
        multiProps: btnData?.postSubmitActionProp?.multiProps,
        record: data,
        urlCode,
        params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
      });
      history.push(route);
    }
    if (btnData?.postSubmitActionProp?.action === "printZenForm") {
      document.getElementsByClassName('customer-complaint')[0].classList.add('printable');
      document.getElementById('print-form').click();
      setTimeout(() => {
        document.getElementsByClassName('customer-complaint')[0].classList.remove('printable');
      }, 2000);
      return;
    }
    if (btnData?.postSubmitActionProp?.action === "blankPage") {
      setModalElement(null);
    };
    if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
      setModalElement(null);
      fetchAPI();
    }
    if (btnData?.postSubmitActionProp?.action === "newTab") {
      let route = createRoute({
        route: btnData.postSubmitActionProp.route,
        props: btnData?.postSubmitActionProp?.props,
        multiProps: btnData?.postSubmitActionProp?.multiProps,
        record: data,
        urlCode,
        params: { ...searchParams, ...btnData?.postSubmitActionProp?.params },
      });
      window.open(route, '_blank');
    };

    if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
      window.location.reload();
    }

    if (btnData?.postSubmitActionProp?.action === 'download') {
      let urlData = { ...btnData?.postSubmitActionProp?.params };
      urlData['token'] = localStorage.getItem("token");
      urlData['urlCode'] = urlCode;
      urlData = { ...searchParams, ...urlData };
      let routeParams = new URLSearchParams(urlData);
      let route = `${process.env.REACT_APP_API_ENDPOINT}${btnData?.postSubmitActionProp?.api}?${routeParams}`;
      window.open(route, '_blank');
      return;
    }
  };

  const fetchAPI = () => {
    setLoader(true);
    if (urlMethod === 'POST') {
      liracrypt.post(urlEndpoint, urlData ? { ...searchParams, ...urlData } : {
        dictName,
        ...paramsData
      }).then(res => {
        if (setSmodalTitle) {
          setSmodalTitle(res.data.config?.pageName);
        };
        if (setPageHeader) {
          setPageHeader(res.data.config?.pageTitle || '');
        }
        setLoader(false);
        setModalElement(res.data.config.modalElements);
        setPageConfig(res.data);
        setFooterButtons(res.data.config.footerButtons);
        setRender(false);
      });
    } else {
      liracrypt.get(urlEndpoint, urlData ? { ...searchParams, ...urlData } : {
        dictName,
        ...paramsData
      }).then(res => {
        if (setSmodalTitle) {
          setSmodalTitle(res.data.config?.pageName);
        }
        if (setPageHeader) {
          setPageHeader(res.data.config?.pageTitle || '');
        }
        setLoader(false);
        setModalElement(res.data.config.modalElements);
        setPageConfig(res.data);
        setFooterButtons(res.data.config.footerButtons);
        setRender(false);
      }).catch(err => {
        setPageHeader("ZenForm XXX")
        ApiErrorComp();
        setLoader(false);
      });
    }
  };

  useEffect(() => {
    if (urlEndpoint) {
      fetchAPI();
    } else {
      setModalElement(null)
    }
  }, [dictName, urlEndpoint, JSON.stringify(searchParams)]);

  const EModal = (
    <HModal
      onResponse={onResponse}
      urlData={{ ...searchParams }}
      btnData={{ ...selectedButton }}
      isModalVisible={isHModalVisible}
      setIsModalVisible={setIsHModalVisible}
      modalMethod={"edit"}
      action={action}
      modalData={null}
      preventSubmitBtnClick={true}
    />
  )


  const saveWithoutValidation = ({ value, button }) => {
    let data = { ...value };
    if (extraData) {
      data = { ...data, ...extraData };
    }

    Object.keys(data).forEach((key) => {

      if (data[key]) {
        if (Array.isArray(data[key]) && LocalDict[key]) {
          data[
            LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
          ] = dayjs(data[key][0]).format(LocalDict[key]).toString();
          data[LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"] =
            dayjs(data[key][1]).format(LocalDict[key]).toString();
          delete data[key];
        } else {
          if (LocalDict[key]) {
            data[key] = dayjs(data[key]).format(LocalDict[key]).toString();
          }
        }
      }
    });
    let sparkTableData = {};
    Object.keys(data).forEach(x => {
      if (x.includes('lira-spark-')) {
        let sparkId = x.split('lira-spark-')[1].split("--");
        sparkTableData[sparkId[0]] = {
          ...sparkTableData[sparkId[0]],
          [sparkId[1]]: data[x]
        };
        delete data[x];
      }
    });
    data = { ...data, tblData: { ...sparkTableData, ...searchParams } };
    // Object.keys(sparkTableData).forEach(x => {
    //   data[x] = sparkTableData[x];
    // })
    let formData = new FormData();
    Object.keys(data).forEach(x => {
      let val = data[x];
      if (typeof val === 'object') {
        if (!(val instanceof File)) {
          val = JSON.stringify(val);
        }
      }
      formData.append(x, val);
    });

    let submitFormDataProp = button?.submitFormDataProp;

    if (submitFormDataProp?.params) {
      Object.keys(submitFormDataProp?.params).forEach(x => {
        formData.append(x, submitFormDataProp?.params[x]);
      })
    }
    Object.keys(paramsData).forEach(x => {
      formData.append(x, paramsData[x]);
    });
    // formData.append('typ', typ);
    // formData.append('subtyp', subtyp);

    if (submitFormDataProp?.method === "POST") {
      setLoading(true);
      if (submitFormDataProp?.dataType === 'formData') {
        liracrypt
          .uploadFile(submitFormDataProp?.url, formData)
          .then(({ data }) => onResponse({ data, button }))
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .post(submitFormDataProp?.url, { ...data, ...paramsData, ...submitFormDataProp?.params })
          .then(({ data }) => onResponse({ data, button }))
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      }
    } else if (submitFormDataProp?.method === "PATCH") {
      setLoading(true);
      if (submitFormDataProp?.dataType === 'formData') {
        liracrypt
          .fileUploadPatch(submitFormDataProp?.url, formData)
          .then(({ data }) => onResponse({ data, button }))
          .catch((err) => {
            setLoading(false);
            console.log(err);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status !== 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .patch(submitFormDataProp?.url, { ...data, ...paramsData, ...submitFormDataProp?.params })
          .then(({ data }) => onResponse({ data, button }))
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      }
    } else if (method === "GET") {
      setLoading(true);

      //convert for GET
      Object.keys(data).forEach((element) => {
        if (Array.isArray(data[element])) {
          let filtered = data[element].filter(function (el) {
            return el != null;
          });
          let temp = filtered.toString();
          data[element] = "[" + temp + "]";
        }
      });

      let formData = new FormData();
      Object.keys(data).forEach(x => {
        formData.append(x, data[x]);
      });
      if (submitFormDataProp?.params) {
        Object.keys(submitFormDataProp?.params).forEach(x => {
          formData.append(x, submitFormDataProp?.params[x]);
        })
      }
      Object.keys(paramsData).forEach(x => {
        formData.append(x, paramsData[x]);
      });
      // formData.append('typ', typ);
      // formData.append('subtyp', subtyp);

      liracrypt
        .uploadFile(url, formData)
        .then((res) => {
          setLoading(false);

          notification.success({ message: res.data.message });
          if (onCallFinish) {
            onCallFinish();
          }

          // hitApi();
          form.resetFields();
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          notification.error({ message: "Oops ! Something went Wrong.." });
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              setLoginError(true);
            }
          }
        });
    }
  };


  const onFinish = (value) => {
    let data = { ...value };
    data = { ...searchParams, ...urlData, ...extraData, ...data };
    // if (extraData) {
    //   data = { ...searchParams, ...data, ...extraData };
    // }
    Object.keys(data).forEach((key) => {

      if (data[key]) {
        if (Array.isArray(data[key]) && LocalDict[key]) {
          data[
            LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
          ] = dayjs(data[key][0]).format(LocalDict[key]).toString();
          data[LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"] =
            dayjs(data[key][1]).format(LocalDict[key]).toString();
          delete data[key];
        } else {
          if (LocalDict[key]) {
            data[key] = dayjs(data[key]).format(LocalDict[key]).toString();
          }
        }
      }
    });
    let sparkTableData = {};
    Object.keys(data).forEach(x => {
      if (x.includes('lira-spark-')) {
        let sparkId = x.split('lira-spark-')[1].split("--");
        sparkTableData[sparkId[0]] = {
          ...sparkTableData[sparkId[0]],
          [sparkId[1]]: data[x]
        };
        delete data[x];
      }
    });
    data = { ...data, tblData: { ...sparkTableData, ...searchParams } };
    // Object.keys(sparkTableData).forEach(x => {
    //   data[x] = sparkTableData[x];
    // })
    let formData = new FormData();
    Object.keys(data).forEach(x => {
      let val = data[x];
      if (typeof val === 'object') {
        if (!(val instanceof File)) {
          val = JSON.stringify(val);
        }
      }
      formData.append(x, val);
    });

    let submitFormDataProp = selectedButton?.submitFormDataProp;

    if (submitFormDataProp?.params) {
      Object.keys(submitFormDataProp?.params).forEach(x => {
        formData.append(x, submitFormDataProp?.params[x]);
      })
    }
    Object.keys(paramsData).forEach(x => {
      formData.append(x, paramsData[x]);
    });
    // formData.append('typ', typ);
    // formData.append('subtyp', subtyp);

    if (submitFormDataProp?.method === "POST") {
      setLoading(true);
      if (submitFormDataProp?.dataType === 'formData') {
        liracrypt
          .uploadFile(submitFormDataProp?.url, formData)
          .then(onResponse)
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .post(submitFormDataProp?.url, { ...data, ...paramsData, ...submitFormDataProp?.params })
          .then(onResponse)
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      }
    } else if (submitFormDataProp?.method === "PATCH") {
      setLoading(true);
      if (submitFormDataProp?.dataType === 'formData') {
        liracrypt
          .fileUploadPatch(submitFormDataProp?.url, formData)
          .then(onResponse)
          .catch((err) => {
            setLoading(false);
            console.log(err);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status !== 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .patch(submitFormDataProp?.url, { ...data, ...paramsData, ...submitFormDataProp?.params })
          .then(onResponse)
          .catch((err) => {
            console.log(err);
            setLoading(false);
            notification.error({ message: "Oops ! Something went Wrong.." });
            if (err.response !== undefined) {
              if (err.response.status === 401) {
                //   ApiErrorComp(err.response.status);

                setLoginError(true);
              }
            }
          });
      }
    } else if (method === "GET") {
      setLoading(true);

      //convert for GET
      Object.keys(data).forEach((element) => {
        if (Array.isArray(data[element])) {
          let filtered = data[element].filter(function (el) {
            return el != null;
          });
          let temp = filtered.toString();
          data[element] = "[" + temp + "]";
        }
      });

      let formData = new FormData();
      Object.keys(data).forEach(x => {
        formData.append(x, data[x]);
      });

      if (submitFormDataProp?.params) {
        Object.keys(submitFormDataProp?.params).forEach(x => {
          formData.append(x, submitFormDataProp?.params[x]);
        })
      }
      Object.keys(paramsData).forEach(x => {
        formData.append(x, paramsData[x]);
      });
      // formData.append('typ', typ);
      // formData.append('subtyp', subtyp);

      liracrypt
        .uploadFile(url, formData)
        .then((res) => {
          setLoading(false);

          notification.success({ message: res.data.message });
          if (onCallFinish) {
            onCallFinish();
          }

          // hitApi();
          form.resetFields();
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          notification.error({ message: "Oops ! Something went Wrong.." });
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              setLoginError(true);
            }
          }
        });
    }
  };

  //   const FormElement = ({ element }) => {
  //     return (

  //     );
  //   };

  const queryElements = (controls) => {
    return (<Row>
      {
        controls.map((data, index) => {
          if (dtArray.includes(data["typ"])) {

            LocalDict[data["data_index"]] = data["format"]
              ? data["format"]
              : "YYYY-MM-DD hh:mm:ss";
            LocalDict["data_index_from"] = data["data_index_from"];
            LocalDict["data_index_to"] = data["data_index_to"];
          }

          if (data.visible) {
            return (
              <React.Fragment key={index}>
                <ZenFormInput
                  urlData={{ ...urlData }}
                  childType={data.childType}
                  pageType={"zenForm"}
                  header={data.header}
                  footer={data.footer}
                  labelColSpan={data["labelColSpan"]}
                  style={data['style']}
                  height={data['height']}
                  layoutPosition="space-between"
                  form={form}
                  LocalDict={LocalDict}
                  rows={data.rows}
                  colSpan={data.colSize || 12}
                  name={data["data_index"]}
                  label={data["label"]}
                  defaultValue={data["default"]}
                  typ={data["typ"]}
                  disabled={data["readOnly"]}
                  source={data["source"]}
                  sourceParams={data["sourceParams"]}
                  auxParams={data["auxParams"]}
                  format={data["format"]}
                  errorMessage={data["errorMessage"]}
                  placeHolder={data["placeHolder"]}
                  required={data["required"]}
                  options={data["data"]}
                  from={data["data_index_from"]}
                  to={data["data_index_to"]}
                  url={data["url"]}
                  includeAll={data["includeAll"]}
                  pname={data["p_data_index"]}
                  defaultFrom={data["defaultFrom"]}
                  defaultTo={data["defaultTo"]}
                  multiSelect={data["multiSelect"]}
                  searchable={data["isSearchable"]}
                  data={data}
                  extraData={extraData}
                  children={data['children']}
                />
              </React.Fragment>
            );
          }
        })}
    </Row>)
  }

  return (
    loader ?
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        width: '100%'
      }}>
        {antIcon}
      </div> :
      <>
        <SessionError loginError={loginError} />
        {
          (pageConfig?.config?.zenFuncs?.fullScreenBtn) ?
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={pageConfig?.config?.fullScreenBtn?.title}>
                <Button
                  style={{ ...pageConfig?.config?.fullScreenBtn?.style }}
                  type="link"
                  icon={
                    fullScreenIcon === 'maximize' ? <FaMaximize style={{ fontSize: pageConfig?.config?.fullScreenBtn?.style?.fontSize }} /> :
                      <FaMinimize style={{ fontSize: pageConfig?.config?.fullScreenBtn?.style?.fontSize }} />
                  }
                  onClick={() => toggleFullScreen()}>
                  {''}
                </Button>
              </Tooltip>
            </div> : <></>
        }



        <div id="zen-form-printable">
          <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={onResponse} />
          {modalHeader ? (
            <>
              <div
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "600",
                  margin: "5px",
                  marginTop: "30px",
                  marginBottom: "20px",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                {modalHeader}
              </div>
            </>
          ) : (
            <></>
          )}
          {
            (pageConfig?.config?.zenFuncs?.headerRoute && pageConfig?.config?.headerRoute?.route) ?
              <Row>
                <Col span={24}>
                  <div style={{ width: '500px', display: 'block', margin: 'auto' }}>
                    <RoutePage route={pageConfig?.config?.headerRoute?.route} params={{ ...urlData, ...pageConfig?.config?.headerRoute?.params }} />
                  </div>
                </Col>
              </Row>
              : <></>
          }
          <ZenMultiLines style={{ backgroundColor: pageConfig?.config?.headerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={pageConfig?.config?.zenFuncs?.headerMultiline || false} singleLineColumns={pageConfig?.config?.headerMultiline?.singleCol || []} multiLineColumns={pageConfig?.config?.headerMultiline?.multiCol || []} />
          {modalElement ? (
            <div ref={(el) => (componentRef = el)} className={'customer-complaint'} style={{ padding: "10px" }}>
              <div className="customer-form">
                <Form
                  name="ReportForm"
                  labelWrap={true}
                  form={form}
                  labelCol={{ span: 8 }}
                  layout={pageConfig?.config?.layout || "vertical"}
                  colon={false}
                  onFinish={onFinish}
                  size="large"
                >
                  {
                    pageConfig?.config?.groupControl ?
                      modalElement.map((groupedElement, groupIndex) => (
                        <>
                          <p style={groupedElement.header.style}>{groupedElement.header.text}</p>
                          <div key={groupIndex} className="grouped-zen-form" style={groupedElement.style}>
                            {queryElements(groupedElement.controls)}
                          </div>
                        </>
                      )) :
                      queryElements(modalElement)
                  }
                  <ZenMultiLines style={{ backgroundColor: pageConfig?.config?.footerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={pageConfig?.config?.zenFuncs?.footerMultiline || false} singleLineColumns={pageConfig?.config?.footerMultiline?.singleCol || []} multiLineColumns={pageConfig?.config?.footerMultiline?.multiCol || []} />
                  {
                    footerButtons && (
                      <Row style={{ width: '100%' }} gutter={24} justify="center">
                        <Col span={24} style={{ display: 'inline-flex', justifyContent: 'center' }}>
                          {Object.keys(footerButtons).map((btn, idx) => {
                            const button = footerButtons[btn];
                            if (button?.buttonProp?.visible) {
                              return (
                                <React.Fragment key={`zenform-footer-btn-${idx}`}>
                                  <FooterButtons
                                    saveForm={({ button }) => saveWithoutValidation({ value: form.getFieldsValue(), button })}
                                    postSubmitAction={onResponse}
                                    openPopupModal={openPopupModal}
                                    openSmodal={openSmodal}
                                    button={button}
                                    setSelectedButton={setSelectedButton}
                                    form={form}
                                    label={button?.buttonProp?.label}
                                    type={button?.buttonProp?.type}
                                    disabled={!button?.buttonProp?.enable}
                                    confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                    submitFormData={button?.submitFormDataProp}
                                  />
                                </React.Fragment>

                              )
                            }
                          })}
                        </Col>
                      </Row>
                    )
                  }
                </Form>
              </div>
              {EModal}
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  //  minHeight: "80vh",
                }}
              >
                <LoadingOutlined
                  style={{ fontSize: 80, color: "#007bff" }}
                  spin
                />
              </div>
            </>
          )}
        </div>
        <ReactToPrint
          trigger={() => <Button style={{ display: 'none' }} id="print-form">Print this out</Button>}
          content={() => componentRef}
          pageStyle={`
          @media print {
            @page { margin: 0; }
          }
          body {
            -webkit-print-color-adjust: exact;
          }
        `}
        />
      </>
  );
}

export default ZenForm;
